import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import FormModal from 'components/FormModal';
import { Alert, Button, Form, InputNumber, } from 'antd';
import { txt } from 'libs/i18n';
import { useSession } from 'components/Authenticated';
import { getLanguageFromTrsx, recalculateSpeakers } from 'api/project-api';
import { ExclamationCircleFilled } from '@ant-design/icons';
import styles from './style.module.less';
const SpeakersModal = ({ visible, enqueueProjectUpdate, onSetSpeakersModalVisible, editorController, action, }) => {
    const [form] = Form.useForm();
    const { session } = useSession();
    const handleSubmit = async (values) => {
        await enqueueProjectUpdate(async (initialProject) => {
            const result = await recalculateSpeakers(session.connection, initialProject, action === 'deleteSpeakers' ? 0 : values.speakers);
            if (result.isSuccess()) {
                const { trsx, project } = result.get();
                const projectLanguage = getLanguageFromTrsx(trsx.content);
                editorController.importTrsx({
                    content: trsx.content,
                    etag: trsx.etag,
                    label: editorController.label,
                    language: projectLanguage,
                }, true, project, true);
                return project;
            }
            return initialProject;
        });
        onSetSpeakersModalVisible(false);
    };
    return (_jsx(FormModal, { open: visible, onCancel: () => onSetSpeakersModalVisible(false), width: 600, title: action === 'deleteSpeakers'
            ? (_jsxs(_Fragment, { children: [_jsx(ExclamationCircleFilled, {}), ' ', txt('deleteAllSpeakers'), "?"] }))
            : txt('changeSpeakersNumber'), footer: [
            _jsx(Button, { type: "default", onClick: () => onSetSpeakersModalVisible(false), children: txt('cancel') }),
            _jsx(Button, { danger: action === 'deleteSpeakers', type: "primary", htmlType: "submit", onClick: () => form.submit(), children: txt(action === 'deleteSpeakers' ? 'delete' : 'change') }, "submit"),
        ], children: _jsx("div", { className: styles.container, children: _jsx("div", { className: styles.form, children: _jsx(Form, { onFinish: handleSubmit, form: form, initialValues: { speakers: 2 }, children: action === 'deleteSpeakers' ? (_jsx("p", { children: txt('deleteAllSpeakersWarning') })) : (_jsxs(_Fragment, { children: [_jsx(Form.Item, { name: "speakers", label: txt('changeSpeakersNumberTo'), children: _jsx(InputNumber, { min: 2, max: 8 }) }), _jsx(Alert, { type: "warning", message: txt('speakersChangeIrreversible'), showIcon: true })] })) }) }) }) }));
};
export default SpeakersModal;
